import _classCallCheck from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
/*
 * EV User Retrieval API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.44
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from "../ApiClient";
import { CiteLinkData } from "./CiteLinkData";
import { InputKey } from "./InputKey";

/**
 * The CitedByCount model module.
 * @module modelrest/CitedByCount
 * @version 1.0
 */
export var CitedByCount = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>CitedByCount</code>.
   * @alias module:modelrest/CitedByCount
   * @class
   */
  function CitedByCount() {
    _classCallCheck(this, CitedByCount);
  }

  /**
   * Constructs a <code>CitedByCount</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:modelrest/CitedByCount} obj Optional instance to populate.
   * @return {module:modelrest/CitedByCount} The populated <code>CitedByCount</code> instance.
   */
  _createClass(CitedByCount, null, [{
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new CitedByCount();
        if (data.hasOwnProperty("inputKey")) obj.inputKey = InputKey.constructFromObject(data["inputKey"]);
        if (data.hasOwnProperty("linkData")) obj.linkData = CiteLinkData.constructFromObject(data["linkData"]);
      }
      return obj;
    }
  }]);
  return CitedByCount;
}();

/**
 * @member {module:modelrest/InputKey} inputKey
 */
CitedByCount.prototype.inputKey = undefined;

/**
 * @member {module:modelrest/CiteLinkData} linkData
 */
CitedByCount.prototype.linkData = undefined;